var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 45,
    rx: 7,
    fill: "#FF0505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2625 18.375H11.7375C11.1218 18.375 10.7781 19.025 11.1593 19.4688L21.4218 31.3687C21.7156 31.7094 22.2812 31.7094 22.5781 31.3687L32.8406 19.4688C33.2218 19.025 32.8781 18.375 32.2625 18.375Z",
    fill: "white",
    fillOpacity: 0.46
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7874 37.1632L22.4266 36.7448C22.4163 36.7328 22.3964 36.7328 22.3859 36.7448L22.0252 37.1632C22.0117 37.1788 22.0238 37.2016 22.0455 37.2016H22.7671C22.7887 37.2016 22.8008 37.1788 22.7874 37.1632Z",
    fill: "white",
    fillOpacity: 0.55
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.125,
    height: 1.125,
    fill: "white",
    transform: "translate(21.8438 36.4062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionOut);
export default __webpack_public_path__ + "static/media/transactionOut.2db20bd02885707db1f0d1b08c57179f.svg";
export { ForwardRef as ReactComponent };